import React from 'react'
import '../App.css'
import Bodygestionproductos from './bodygestionproductos'
export class Bodyappgestionproductosbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodygestionproductos/>
            </div>

        );
    }
}